<template>
  <div class="container">
    <div class="row justify-content-center">
      <FullLoader v-if="loading" />
      <div v-else-if="errMessage" class="alert alert-danger" role="alert">
        {{ errMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import FullLoader from '@/components/MainContent/FullLoader'
import { trackEvent } from '@/lib/analytics'
import { createNamespacedHelpers } from 'vuex'
const IntegrationModule = createNamespacedHelpers('integration')
const CompanyModule = createNamespacedHelpers('company')

function resolveOauthFailureMessage(body, genericErrorMessage) {
  return body?.message || genericErrorMessage
}

export default {
  name: 'OauthView',
  components: {
    FullLoader
  },
  data() {
    return {
      loading: true,
      errMessage: ''
    }
  },
  computed: {
    integrationProviderName() {
      return this.$route && this.$route.params ? this.$route.params.integrationProviderName : null
    },
    queryParams() {
      return this.$route && this.$route.query ? this.$route.query : null
    }
  },
  methods: {
    ...IntegrationModule.mapActions(['updateIntegrationOauth']),
    ...CompanyModule.mapActions(['createOauthAccount'])
  },
  async mounted() {
    const genericErrorMessage = `There was an issue processing your Oauth request.`
    try {
      trackEvent(this.$intercom, 'Oauth')
      localStorage.removeItem('oauthInputName')
      localStorage.removeItem(`oauthInputName:${this.integrationProviderName}`)
      const storageKey = `integrationNickname:${this.integrationProviderName}`
      const name = localStorage.getItem(storageKey)
      localStorage.removeItem(storageKey)
      let redirectUrl

      if (name) {
        const res = await this.createOauthAccount({
          integrationProviderName: this.integrationProviderName,
          name,
          oauth: this.queryParams
        })

        if (res) {
          redirectUrl = res.body.data.redirectUrl
        }

        if (!redirectUrl) {
          this.errMessage = resolveOauthFailureMessage(res?.body, genericErrorMessage)
          this.$notify({
            title: 'Oauth Error',
            type: 'error',
            text: this.errMessage
          })
        }
      } else {
        const result = await this.updateIntegrationOauth({
          integrationProviderName: this.integrationProviderName,
          oauth: this.queryParams
        })
        const resultBody = result?.data || result?.body
        const isFailure = result?.ok === false || resultBody?.success === false
        redirectUrl = resultBody?.data?.redirectUrl

        if (isFailure || !redirectUrl) {
          this.errMessage = resolveOauthFailureMessage(resultBody, genericErrorMessage)
          this.$notify({
            title: 'Oauth Error',
            type: 'error',
            text: this.errMessage
          })
        }
      }

      console.log('redirectUrl', redirectUrl)
      if (redirectUrl) {
        this.$router.replace(redirectUrl)
      } else {
        this.loading = false
      }
    } catch (error) {
      console.log(error)
      this.errMessage = genericErrorMessage
      this.loading = false
      this.$notify({
        title: 'Oauth Error',
        type: 'error',
        text: genericErrorMessage
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
